<template>
  <div class="new-registration-container">
    <bert-loading 
      v-if="isLoading" 
      :fullscreen="true" 
      size="lg" 
      text="Loading"
    />

    <!-- Main Content -->
    <div v-else class="registration-wrapper">
      <!-- Desktop Layout -->
      <div class="desktop-layout">
        <!-- Left Side - Banner -->
        <div class="banner-section">
          <div class="banner-content">
            <img src="@/assets/banner-auth.svg" alt="Community Banner" class="banner-image" />
            <div class="member-badge">
              <img src="@/assets/sub-banner-auth.svg" alt="5000+ Members" class="member-image" />
            </div>
          </div>
        </div>

        <!-- Right Side - Registration Form -->
        <div class="form-section">
          <div class="form-container">
            <!-- Logo -->
            <div class="logo-container">
              <img src="@/assets/berts-logo-header.png" alt="Bert Points Logo" class="logo" />
            </div>

            <!-- Form Title -->
            <h2 class="form-title">Member Registration</h2>

            <!-- Registration Form -->
            <form @submit.prevent="submitData" class="registration-form">
              <div class="form-row">
                <div class="form-group">
                  <label for="name">Nama Lengkap :</label>
                  <div class="input-wrapper">
                    <i class="input-icon mdi mdi-account"></i>
                    <input
                      type="text"
                      id="name"
                      v-model="forms.name"
                      placeholder="Masukkan Nama Lengkap"
                      required
                    />
                  </div>
                </div>

                <div class="form-group">
                  <label for="email">Email :</label>
                  <div class="input-wrapper">
                    <i class="input-icon mdi mdi-email"></i>
                    <input
                      type="email"
                      id="email"
                      v-model="forms.email"
                      placeholder="Masukkan Email Aktif"
                      required
                    />
                  </div>
                </div>
              </div>

              <div class="form-row">
                <div class="form-group">
                  <label for="phone">No Handphone :</label>
                  <div class="input-wrapper">
                    <i class="input-icon mdi mdi-phone"></i>
                    <input
                      type="tel"
                      id="phone"
                      v-model="forms.phone"
                      placeholder="Masukkan Nomor Handphone"
                      required
                    />
                  </div>
                </div>

                <div class="form-group">
                  <label for="community">Community :</label>
                  <div class="input-wrapper">
                    <i class="input-icon mdi mdi-account-group"></i>
                    <select id="community" v-model="selectedOption" required>
                      <option disabled value="">Pilih Community</option>
                      <option v-for="option in options" :key="option.id" :value="option.id">
                        {{ option.community }}
                      </option>
                    </select>
                    <i class="select-arrow mdi mdi-chevron-down"></i>
                  </div>
                </div>
              </div>

              <div class="form-row">
                <div class="form-group">
                  <label for="password">Kata Sandi :</label>
                  <div class="input-wrapper">
                    <i class="input-icon mdi mdi-lock"></i>
                    <input
                      type="password"
                      id="password"
                      v-model="forms.password"
                      placeholder="Masukkan Kata Sandi"
                      required
                    />
                    <i class="password-toggle mdi mdi-eye" @click="togglePassword('password')"></i>
                  </div>

                </div>

                <div class="form-group">
                  <label for="password_conf">Ulangi Kata Sandi :</label>
                  <div class="input-wrapper">
                    <i class="input-icon mdi mdi-lock"></i>
                    <input
                      type="password"
                      id="password_conf"
                      v-model="forms.password_konf"
                      placeholder="Ulangi Kata Sandi"
                      required
                    />
                    <i class="password-toggle mdi mdi-eye" @click="togglePassword('password_conf')"></i>
                  </div>
                </div>
              </div>

              <!-- Login Link -->
              <div class="login-link">
                Sudah Punya Akun? <router-link to="/login" class="link-primary">Masuk Disini</router-link>
              </div>

              <!-- Form Actions -->
              <div class="form-actions">
                <bert-button 
                  type="submit" 
                  variant="primary" 
                  size="lg"
                  :full-width="true"
                  :loading="isLoading"
                  :disabled="isLoading"
                >
                  Daftar
                </bert-button>
                <bert-button 
                  type="button" 
                  variant="outline" 
                  size="lg"
                  :full-width="true"
                  @click="resetForm"
                >
                  Batal
                </bert-button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <!-- Mobile Layout -->
      <div class="mobile-layout">
        <div class="mobile-container">
          <!-- Logo -->
          <div class="mobile-logo">
            <img src="@/assets/berts-logo-header.png" alt="Bert Points Logo" class="logo" />
          </div>

          <!-- Form Title -->
          <h2 class="mobile-title">Member Registration</h2>

          <!-- Registration Form -->
          <form @submit.prevent="submitData" class="mobile-form">
            <div class="mobile-form-group">
              <label for="mobile-name">Nama Lengkap :</label>
              <div class="mobile-input-wrapper">
                <i class="input-icon mdi mdi-account"></i>
                <input
                  type="text"
                  id="mobile-name"
                  v-model="forms.name"
                  placeholder="Masukkan Nama Lengkap"
                  required
                />
              </div>
            </div>

            <div class="mobile-form-group">
              <label for="mobile-email">Email :</label>
              <div class="mobile-input-wrapper">
                <i class="input-icon mdi mdi-email"></i>
                <input
                  type="email"
                  id="mobile-email"
                  v-model="forms.email"
                  placeholder="Masukkan Email Aktif"
                  required
                />
              </div>
            </div>

            <div class="mobile-form-group">
              <label for="mobile-phone">No Handphone :</label>
              <div class="mobile-input-wrapper">
                <i class="input-icon mdi mdi-phone"></i>
                <input
                  type="tel"
                  id="mobile-phone"
                  v-model="forms.phone"
                  placeholder="Masukkan Nomor Handphone"
                  required
                />
              </div>
            </div>

            <div class="mobile-form-group">
              <label for="mobile-community">Community :</label>
              <div class="mobile-input-wrapper">
                <i class="input-icon mdi mdi-account-group"></i>
                <select id="mobile-community" v-model="selectedOption" required>
                  <option disabled value="">Pilih Community</option>
                  <option v-for="option in options" :key="option.id" :value="option.id">
                    {{ option.community }}
                  </option>
                </select>
                <i class="select-arrow mdi mdi-chevron-down"></i>
              </div>
            </div>

            <div class="mobile-form-group">
              <label for="mobile-password">Kata Sandi :</label>
              <div class="mobile-input-wrapper">
                <i class="input-icon mdi mdi-lock"></i>
                <input
                  type="password"
                  id="mobile-password"
                  v-model="forms.password"
                  placeholder="Masukkan Kata Sandi"
                  required
                />
                <i class="password-toggle mdi mdi-eye" @click="togglePassword('mobile-password')"></i>
              </div>

            </div>

            <div class="mobile-form-group">
              <label for="mobile-password-conf">Ulangi Kata Sandi :</label>
              <div class="mobile-input-wrapper">
                <i class="input-icon mdi mdi-lock"></i>
                <input
                  type="password"
                  id="mobile-password-conf"
                  v-model="forms.password_konf"
                  placeholder="Ulangi Kata Sandi"
                  required
                />
                <i class="password-toggle mdi mdi-eye" @click="togglePassword('mobile-password-conf')"></i>
              </div>
            </div>

            <!-- Login Link -->
            <div class="mobile-login-link">
              Sudah Punya Akun? <router-link to="/new-login" class="link-primary">Masuk Disini</router-link>
            </div>

            <!-- Form Actions -->
            <div class="mobile-form-actions">
              <bert-button 
                type="submit" 
                variant="primary" 
                size="lg"
                :full-width="true"
                :loading="isLoading"
                :disabled="isLoading"
              >
                Daftar
              </bert-button>
              <bert-button 
                type="button" 
                variant="outline" 
                size="lg"
                :full-width="true"
                @click="resetForm"
              >
                Batal
              </bert-button>
            </div>
          </form>
        </div>
      </div>

      <!-- Footer -->
      <footer class="auth-footer">
        <div class="footer-content">
          <p>&copy; Copyright 2025 Bert Solution All rights reserved.</p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import BertButton from '@/components/ui/Button.vue';
import BertLoading from '@/components/ui/Loading.vue'

export default {
  name: "NewUserRegistration",
  components: {
    BertButton,
    BertLoading
  },
  data() {
    return {
      isLoading: false,
      errors: [],
      forms: {
        name: "",
        email: "",
        phone: "",
        password: "",
        password_konf: ""
      },
      selectedOption: "",
      options: []
    };
  },
  computed: {
    // Removed password validation - users can set any password
  },
  methods: {
    loadItems() {
      const baseURI = this.$settings.endPoint + "get-community";
      this.isLoading = true;
      return this.$http
        .get(baseURI, {
          timeout: 10000,
          headers: {
            AppToken: this.$settings.jwtSecret
          }
        })
        .then(response => {
          this.isLoading = false;
          this.options = response.data.datas;
        })
        .catch(error => {
          this.isLoading = false;
          console.log("Error:", error);

          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else if (error.response.status === 401) {
                this.$router.push("/authorized-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },

    submitData() {
      if (this.forms.name.trim()) {
        // Check password confirmation match
        if (this.forms.password !== this.forms.password_konf) {
          this.error("Konfirmasi kata sandi tidak cocok");
          return;
        }

        let formData = new FormData();
        formData.append("name", this.forms.name.trim());
        formData.append("email", this.forms.email);
        formData.append("phone", this.forms.phone);
        formData.append("password", this.forms.password);
        formData.append("password_konf", this.forms.password_konf);
        formData.append("community_id", this.selectedOption);

        const baseURI = this.$settings.endPoint + "auth/register";
        this.isLoading = true;

        this.$http
          .post(baseURI, formData)
          .then(response => {
            this.isLoading = false;
            if (response.data.status === 200) {
              this.success("Registrasi berhasil! Silakan login.");
              setTimeout(() => {
                this.$router.push("/login");
              }, 2000);
            } else {
              this.errors = response.data.errors;
              this.resultError(response.data.errors);
            }
          })
          .catch(error => {
            this.isLoading = false;
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          });
      } else {
        this.error("Nama lengkap wajib diisi");
      }
    },

    resetForm() {
      this.forms = {
        name: "",
        email: "",
        phone: "",
        password: "",
        password_konf: ""
      };
      this.selectedOption = "";
    },

    togglePassword(fieldId) {
      const field = document.getElementById(fieldId);
      const icon = field.nextElementSibling;
      
      if (field.type === "password") {
        field.type = "text";
        icon.classList.remove("mdi-eye");
        icon.classList.add("mdi-eye-off");
      } else {
        field.type = "password";
        icon.classList.remove("mdi-eye-off");
        icon.classList.add("mdi-eye");
      }
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(message) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: toast => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        }
      });
      Toast.fire({
        icon: "success",
        title: message
      });
    },

    error(message) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: toast => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        }
      });
      Toast.fire({
        icon: "error",
        title: message
      });
    }
  },

  mounted() {
    this.loadItems();
  }
};
</script>

<style scoped>
/* Global Styles */
.new-registration-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  font-family: 'Roboto', sans-serif;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loading-content {
  text-align: center;
}

.registration-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* Desktop Layout */
.desktop-layout {
  display: flex;
  min-height: calc(100vh - 60px);
  flex: 1;
}

.banner-section {
  flex: 0.7;
  background: url('~@/assets/banner-auth.svg') ;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 2rem;
}

.banner-content {
  text-align: center;
  position: relative;
}

.banner-image {
  max-width: 100%;
  height: auto;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

.member-badge {
  position: absolute;
  bottom: -20px;
  left: 50%;
  transform: translateX(-50%);
}

.member-image {
  max-width: 280px;
  height: auto;
}

.form-section {
  flex: 1;
  display: flex;
  align-items: start;
  justify-content: start;
  padding: 2rem;
  background: white;
}

.form-container {
  width: 100%;
  padding: 2rem;
}

.logo-container {
  text-align: start;
  margin-bottom: 2rem;
}

.logo {
  height: 60px;
  width: auto;
}

.form-title {
  font-size: 2rem;
  font-weight: 700;
  color: #2c3e50;
  text-align: start;
  margin-bottom: 2rem;
}

.registration-form {
  width: 100%;
}

.form-row {
  display: flex;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.form-group {
  flex: 1;
}

.form-group label {
  display: block;
  font-weight: 500;
  color: #2c3e50;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
}

.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.input-icon {
  position: absolute;
  left: 12px;
  color: #6c757d;
  font-size: 1.1rem;
  z-index: 2;
}

.input-wrapper input,
.input-wrapper select {
  width: 100%;
  padding: 12px 12px 12px 40px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 0.9rem;
  transition: all 0.3s ease;
  background: #f8f9fa;
}

.input-wrapper input:focus,
.input-wrapper select:focus {
  outline: none;
  border-color: #ffc107;
  background: white;
  box-shadow: 0 0 0 3px rgba(255, 193, 7, 0.1);
}

.input-wrapper select {
  appearance: none;
  cursor: pointer;
  padding-right: 40px;
}

.select-arrow {
  position: absolute;
  right: 12px;
  color: #6c757d;
  pointer-events: none;
}

.password-toggle {
  position: absolute;
  right: 12px;
  color: #6c757d;
  cursor: pointer;
  font-size: 1.1rem;
}

.password-toggle:hover {
  color: #495057;
}

.password-requirements {
  margin-top: 0.5rem;
  padding: 0.5rem 0;
}

.requirement {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.8rem;
  color: #6c757d;
  margin-bottom: 0.25rem;
}

.requirement.valid {
  color: #28a745;
}

.requirement i {
  font-size: 0.9rem;
}

.login-link {
  text-align: center;
  margin: 1.5rem 0;
  color: #6c757d;
}

.link-primary {
  color: #ffc107;
  text-decoration: none;
  font-weight: 600;
}

.link-primary:hover {
  color: #e0a800;
  text-decoration: underline;
}

.form-actions {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 3rem;
}

/* Mobile Layout */
.mobile-layout {
  display: none;
  padding: 1rem;
}

.mobile-container {
  background: white;
  border-radius: 15px;
  padding: 2rem 1.5rem;
  margin: 1rem 0;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

.mobile-logo {
  text-align: center;
  margin-bottom: 1.5rem;
}

.mobile-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #2c3e50;
  text-align: center;
  margin-bottom: 1.5rem;
}

.mobile-form-group {
  margin-bottom: 1.5rem;
}

.mobile-form-group label {
  display: block;
  font-weight: 500;
  color: #2c3e50;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
}

.mobile-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.mobile-input-wrapper input,
.mobile-input-wrapper select {
  width: 100%;
  padding: 12px 12px 12px 40px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 0.9rem;
  transition: all 0.3s ease;
  background: #f8f9fa;
}

.mobile-input-wrapper input:focus,
.mobile-input-wrapper select:focus {
  outline: none;
  border-color: #ffc107;
  background: white;
  box-shadow: 0 0 0 3px rgba(255, 193, 7, 0.1);
}

.mobile-input-wrapper select {
  appearance: none;
  cursor: pointer;
  padding-right: 40px;
}

.mobile-login-link {
  text-align: center;
  margin: 1.5rem 0;
  color: #6c757d;
}

.mobile-form-actions {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 2rem;
}

/* Footer */
.auth-footer {
  background: #2c3e50;
  color: white;
  padding: 1rem 0;
  text-align: center;
  margin-top: auto;
}

.footer-content p {
  margin: 0;
  font-size: 0.9rem;
}

/* Responsive Design */
@media (max-width: 768px) {
  .desktop-layout {
    display: none;
  }
  
  .mobile-layout {
    display: block;
  }
  
  .form-row {
    flex-direction: column;
    gap: 0;
  }
  
  .new-registration-container {
    padding: 0;
  }
}

@media (max-width: 1024px) {
  .banner-section {
    flex: 0.8;
  }
  
  .form-section {
    flex: 1.2;
  }
}

/* Animation */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.form-container,
.mobile-container {
  animation: fadeIn 0.6s ease-out;
}

/* Focus states for accessibility */
.input-wrapper input:focus,
.input-wrapper select:focus,
.mobile-input-wrapper input:focus,
.mobile-input-wrapper select:focus {
  outline: 2px solid #ffc107;
  outline-offset: 2px;
}

.btn-register:focus,
.btn-cancel:focus,
.mobile-btn-register:focus,
.mobile-btn-cancel:focus {
  outline: 2px solid #ffc107;
  outline-offset: 2px;
}
</style>